import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-latex-grammar-checker',
  templateUrl: './latex-grammar-checker.component.html',
  styleUrls: ['./latex-grammar-checker.component.scss']
})
export class LatexGrammarCheckerComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('LaTeX文法チェッカー・LaTeXファイル校正 | Trinka');
    this.metaTagService.updateTag({ name: 'description', content: " LaTeXファイルの文法チェックをワンクリックで自動で行えるTrinkaのLaTeXファイル自動校正機能。時間の節約、英文執筆の作業効率化に。" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'LaTeX文法チェッカー・LaTeXファイル校正 | Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: ' LaTeXファイルの文法チェックをワンクリックで自動で行えるTrinkaのLaTeXファイル自動校正機能。時間の節約、英文執筆の作業効率化に。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features/latex-grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Latex-banner.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'LaTeX文法チェッカー・LaTeXファイル校正 | Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "LaTeXファイルの文法チェックをワンクリックで自動で行えるTrinkaのLaTeXファイル自動校正機能。時間の節約、英文執筆の作業効率化に。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Latex-banner.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/jp/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/latex-grammar-checker' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../../assets/js/wisepop.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/joaE-2djPGE" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  
}
